var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          dense: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "grey-900" },
                    on: { click: _vm.handleCreateCategory },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v("mdi-plus-box"),
                    ]),
                    _vm._v("Crear categoría"),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "pa-0 mt-0 mb-10" },
        [
          _vm.loading
            ? _c("VSkeleton", { staticClass: "mt-6" })
            : [
                _c(
                  "v-col",
                  { staticClass: "px-0 mt-2", attrs: { cols: "12" } },
                  [
                    _vm.categoriesList.length
                      ? [
                          _c(
                            "v-row",
                            _vm._l(_vm.categoriesList, function (d, index) {
                              return _c(
                                "v-col",
                                {
                                  key: `${d.id}-${index}`,
                                  staticClass: "pa-2 d-flex",
                                  attrs: { cols: "6", md: "4" },
                                },
                                [
                                  _c("v-hover", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ hover }) {
                                            return [
                                              _c(
                                                "v-card",
                                                {
                                                  staticClass:
                                                    "pa-5 rounded-md d-flex flex-column",
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    elevation: hover ? 5 : 0,
                                                    flat: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.$router.push({
                                                        name: "SuppliersCategoriesRetrieveUpdate",
                                                        params: {
                                                          id: d?.id ?? "null",
                                                          ..._vm.currentParams,
                                                        },
                                                      })
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticStyle: {
                                                        height: "50px",
                                                      },
                                                      attrs: {
                                                        align: "start",
                                                        "no-gutters": "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "pa-0 d-flex align-center",
                                                          attrs: { cols: "11" },
                                                        },
                                                        [
                                                          _c(
                                                            "v-avatar",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  _vm.isDefaultSegment(
                                                                    d.id
                                                                  )
                                                                    ? "yellow-100"
                                                                    : d.name ===
                                                                      "Bloqueados"
                                                                    ? "grey-200"
                                                                    : "green-100",
                                                                size: "32",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      _vm.isDefaultSegment(
                                                                        d.id
                                                                      )
                                                                        ? "yellow-500"
                                                                        : d.name ===
                                                                          "Bloqueados"
                                                                        ? "grey-300"
                                                                        : "green-500",
                                                                    size: "20",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-" +
                                                                      _vm._s(
                                                                        d.name ===
                                                                          "Bloqueados"
                                                                          ? "lock"
                                                                          : "folder"
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              class: `${
                                                                _vm.isDefaultSegment(
                                                                  d.id
                                                                )
                                                                  ? "grey-200"
                                                                  : "grey-500"
                                                              }--text pl-3 font-weight-semibold subtitle-2 line-clamp-2 `,
                                                              staticStyle: {
                                                                flex: "1",
                                                                "max-width":
                                                                  "90%",
                                                                "padding-top":
                                                                  "6px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.isDefaultSegment(
                                                                    d.id
                                                                  )
                                                                    ? "Sin categoría"
                                                                    : d.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("v-spacer"),
                                                      !_vm.isDefaultSegment(
                                                        d.id
                                                      )
                                                        ? _c(
                                                            "v-menu",
                                                            {
                                                              attrs: {
                                                                "close-on-click":
                                                                  "",
                                                                "offset-y": "",
                                                                left: "",
                                                                "nudge-bottom": 0,
                                                                "nudge-left": 10,
                                                                transition:
                                                                  "slide-y-transition",
                                                                "min-width": 182,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                        attrs,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              _vm._b(
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-n1 mr-n2",
                                                                                  attrs:
                                                                                    {
                                                                                      text: "",
                                                                                      ripple: false,
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        $event.stopPropagation()
                                                                                      },
                                                                                  },
                                                                                },
                                                                                "v-btn",
                                                                                attrs,
                                                                                false
                                                                              ),
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      color:
                                                                                        "grey-500",
                                                                                      size: "24",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-dots-vertical"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                              model: {
                                                                value:
                                                                  _vm.menu[
                                                                    index
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.menu,
                                                                      index,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "menu[index]",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list",
                                                                {
                                                                  staticClass:
                                                                    "pa-0 pb-2",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      staticClass:
                                                                        "px-3 mt-1",
                                                                      attrs: {
                                                                        "active-class":
                                                                          "transparent",
                                                                        ripple: false,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.handleCategory(
                                                                              d
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        {
                                                                          staticClass:
                                                                            "body-2",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Editar categoría"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  d.qty_members ===
                                                                  0
                                                                    ? _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "px-3",
                                                                          attrs:
                                                                            {
                                                                              "active-class":
                                                                                "transparent",
                                                                              ripple: false,
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.handleDestroyCategory(
                                                                                  d.id
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            {
                                                                              staticClass:
                                                                                "body-2",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Eliminar categoría"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pt-2 flex-grow-1 d-flex align-start",
                                                      staticStyle: {
                                                        "line-height": "1",
                                                      },
                                                    },
                                                    [
                                                      _vm.isDefaultSegment(d.id)
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "grey-500--text body-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "No presenta clasificación específica"
                                                              ),
                                                            ]
                                                          )
                                                        : d.description
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "grey-500--text body-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  d.description
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2 text--disabled font-italic",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Sin especificar"
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pt-3 mt-auto",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "grey-300--text body-1 d-block",
                                                        },
                                                        [_vm._v("Proveedores")]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-block mt-n1 grey-300--text font-weight-bold subtitle-q",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              d.qty_members ?? 0
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ]
                      : _c(
                          "div",
                          {
                            staticClass: "d-flex justify-center align-center",
                            staticStyle: {
                              width: "100%",
                              "min-height": "calc(100vh - 300px)",
                            },
                          },
                          [
                            _c("v-empty-state", {
                              attrs: {
                                title: "No existen categorías para mostrar",
                                isFree: true,
                                type: "suppliers",
                                height: 200,
                                customClass: "mt-5",
                                hiddenDescription: true,
                              },
                            }),
                          ],
                          1
                        ),
                  ],
                  2
                ),
              ],
        ],
        2
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "650",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogCategory,
            callback: function ($$v) {
              _vm.dialogCategory = $$v
            },
            expression: "dialogCategory",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Editar categoría")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogCategory = false
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { size: "24" } }, [
                                    _vm._v("mdi-close"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "pb-4 pt-5 px-5",
                  staticStyle: { "max-height": "600px !important" },
                },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0 transparent v-list-form-card" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "pb-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Nombre")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.editable.name.$error,
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                  placeholder:
                                    "Escribe el nombre de la categoría",
                                },
                                model: {
                                  value: _vm.$v.editable.name.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.editable.name,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.editable.name.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Descripción")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.editable.description.$error,
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "200",
                                  "hide-details": "",
                                  placeholder:
                                    "Escribe una descripción de la categoría",
                                },
                                model: {
                                  value: _vm.$v.editable.description.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.editable.description,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.editable.description.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogCategory = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.editCategoryLoading,
                      },
                      on: { click: _vm.editCategory },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogDelete,
            callback: function ($$v) {
              _vm.dialogDelete = $$v
            },
            expression: "dialogDelete",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Eliminar categoría")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogDelete = false),
                                        (_vm.confirm = "")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass:
                        "inf-alert-yellow yellow-700--text rounded-md mb-4",
                      attrs: { dense: "", outlined: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex pa-0 align-center" },
                        [
                          _c("v-icon", { attrs: { color: "yellow-700" } }, [
                            _vm._v("mdi-alert-outline"),
                          ]),
                          _c("div", { staticClass: "ml-4" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-1 font-weight-bold yellow-700--text",
                              },
                              [_vm._v("Atención")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "d-block body-2 yellow-700--text",
                              },
                              [
                                _vm._v(
                                  "Al eliminar la categoría, los proveedores no tendrán categorías asociadas y estarán sujetos a las reglas de automatización para proveedores sin categorías."
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("span", { staticClass: "d-block grey-500--text mb-2" }, [
                    _vm._v("Escribe "),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v('"confirmar"'),
                    ]),
                    _vm._v(" para continuar."),
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      "single-line": "",
                      maxlength: "9",
                      "hide-details": "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        _vm.confirm.toLowerCase() === "confirmar" &&
                          _vm.destroyCategory()
                      },
                    },
                    model: {
                      value: _vm.confirm,
                      callback: function ($$v) {
                        _vm.confirm = $$v
                      },
                      expression: "confirm",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogDelete = false), (_vm.confirm = "")
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.destroyCategory },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "650",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogCreateCategory,
            callback: function ($$v) {
              _vm.dialogCreateCategory = $$v
            },
            expression: "dialogCreateCategory",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Crear categoría")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogCreateCategory = false
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { size: "24" } }, [
                                    _vm._v("mdi-close"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  staticClass: "pb-4 pt-6 px-5",
                  staticStyle: { "max-height": "600px !important" },
                },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0 transparent v-list-form-card" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "py-1" },
                        [
                          _c("v-list-item-title", [_vm._v("Nombre")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  error: _vm.$v.newCategory.name.$error,
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.$v.newCategory.name.$model,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.$v.newCategory.name,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.newCategory.name.$model",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { staticClass: "pb-2 pt-2" },
                        [
                          _c("v-list-item-title", [_vm._v("Descripción")]),
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "100",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.newCategory.description,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newCategory,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "newCategory.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogCreateCategory = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.createCategoryLoading,
                      },
                      on: { click: _vm.createCategory },
                    },
                    [_vm._v("Crear")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }